export default __webpack_public_path__ + "static/media/single_web-md@2x.11bc3e08.jpg";